import { requestWrapper } from 'e-submission/domain/data'

export const getDataAuraMiddleware = (user, current_app_id) => {
  return requestWrapper.getRequest(`application/${current_app_id}`, user).then(({ data }) => data)
}
